import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import BeforeAfterSlider from "@/components/BeforeAfterSlider";
import ProblemSection from "@/components/ProblemSection";
import SolutionSection from "@/components/SolutionSection";
import ServicesSection from "@/components/ServicesSection";
import AdvantagesSection from "@/components/AdvantagesSection";
import TrustSection from "@/components/TrustSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import PricingSection from "@/components/PricingSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import MobileStickyBar from "@/components/MobileStickyBar";
import Seo, { businessSchema } from "@/components/seo/Seo";
import CoveringCuisinePage from "@/pages/CoveringCuisinePage";
import CoveringAinPage from "@/pages/CoveringAinPage";
import CoveringLyonPage from "@/pages/CoveringLyonPage";
import RealisationsPage from "@/pages/RealisationsPage";
import ZonesInterventionPage from "@/pages/ZonesInterventionPage";
import ContactPage from "@/pages/ContactPage";
import NotFoundPage from "@/pages/NotFoundPage";

function HomePage() {
  return (
    <div className="min-h-screen bg-[#0284FC]">
      <Seo
        title="Covering cuisine Lyon & Ain | Rénovation sans tout remplacer – Vinylux"
        description="Vinylux rénove les cuisines par covering dans l'Ain, à Lyon et alentours. Façades, meubles, plans de travail et crédences selon faisabilité. Devis gratuit."
        path="/"
        schema={businessSchema}
      />
      <Navigation />
      <main className="pb-20 lg:pb-0">
        <HeroSection />
        <BeforeAfterSlider />
        <ProblemSection />
        <SolutionSection />
        <ServicesSection />
        <AdvantagesSection />
        <TrustSection />
        <TestimonialsSection />
        <PricingSection />
        <ContactSection />
      </main>
      <Footer />
      <MobileStickyBar />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/covering-cuisine" element={<CoveringCuisinePage />} />
        <Route path="/covering-cuisine-ain" element={<CoveringAinPage />} />
        <Route path="/covering-cuisine-lyon" element={<CoveringLyonPage />} />
        <Route path="/realisations" element={<RealisationsPage />} />
        <Route path="/zones-intervention" element={<ZonesInterventionPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
